import { Text, View } from "@react-pdf/renderer";
import { connect } from "react-redux";
import formatMoney from "../helpers/formatMoney";
import { RootState } from "../state/reducers";
import { ChoiceState } from "../state/reducers/choiceReducer";
import { PackagedState } from "../state/reducers/packagedReducer";
import { Choice, FormData, Page } from "../types";
import styles from "./PdfStyles";

interface PdfChoiceProps {
  page: Page;
  choice: Choice;
  choices: ChoiceState;
  packaged: PackagedState;
  formData: FormData;
}

const PdfChoice: React.FC<PdfChoiceProps> = ({
  page,
  choice,
  choices,
  packaged,
  formData,
}) => {
  const isPackaged = packaged.allIds.includes(choice.id);
  const section = formData.entities.sections.byId[choice.sectionId];
  if (!section) return null;

  const packagedChoice = packaged.byId[choice.id];
  const packagedChoiceOwnerId = packagedChoice?.fromId;
  const packagedChoiceOwner = packagedChoiceOwnerId
    ? choices.byId[packagedChoiceOwnerId]
    : undefined;
  const packagedChoiceOwnerLabel = packagedChoiceOwner
    ? packagedChoiceOwner.label
    : "";
  return (
    <View style={styles.row}>
      <View style={styles.column}>
        <View style={{ display: "flex" }}>
          <Text style={styles.text}>
            {page.short === "colors"
              ? `${section.label} - ${choice.label}`
              : choice.label}
          </Text>
          {choice.quantity > 1 ? (
            <Text
              style={{ ...styles.text, fontWeight: "bold" }}
            >{` x ${choice.quantity}`}</Text>
          ) : (
            <></>
          )}
        </View>
      </View>
      <View style={styles.column}>
        {isPackaged ? (
          <Text
            style={{
              ...styles.price,
              fontSize: 8,
              color: "#000000",
            }}
          >
            {`Included in ${packagedChoiceOwnerLabel}`}
          </Text>
        ) : choice.discount ? (
          <View>
            <Text style={styles.price}>{formatMoney(choice.discount)}</Text>
            <Text
              style={{
                ...styles.price,
                fontSize: 8,
                fontWeight: "normal",
                color: "#5d5d5d",
              }}
            >
              {formatMoney(choice.price)}
            </Text>
          </View>
        ) : choice.price !== null ? (
          <Text style={styles.price}>{formatMoney(choice.price)}</Text>
        ) : null}
      </View>
    </View>
  );
};

const PdfChoiceConnect = connect((state: RootState) => {
  return {
    choices: state.choices,
    packaged: state.packaged,
    formData: state.formData,
  };
}, {})(PdfChoice);

export default PdfChoiceConnect;
